import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-top-loading-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed top-0 left-0 w-full h-[3px] z-[9999] pointer-events-none transition-opacity duration-300"
         [class.opacity-100]="loadingService.isLoading()"
         [class.opacity-0]="!loadingService.isLoading()">
      <div class="h-full rounded-r-full gradient-bar"
           [class.loading-bar-animate]="loadingService.isLoading()">
      </div>
    </div>
  `,
  styles: [`
    .gradient-bar {
      background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);
      background-size: 200% 100%;
    }
    .loading-bar-animate {
      animation: loadingBar 2s ease-in-out infinite, gradientMove 2s linear infinite;
      transform-origin: left;
    }
    
    @keyframes loadingBar {
      0% { width: 0%; transform: translateX(0); }
      50% { width: 100%; transform: translateX(0); }
      100% { width: 100%; transform: translateX(100%); }
    }
    @keyframes gradientMove {
      0% { background-position: 100% 0; }
      100% { background-position: -100% 0; }
    }
  `]
})
export class TopLoadingBarComponent {
  constructor(public loadingService: LoadingService) {}
}
